export const CRM_SEARCH_DEBOUNCE_MS = 300;
export const CRM_SEARCH_MIN_LENGTH = 2;

export function getDebouncedSearchTerm(searchText: string, activeSearch: string): string | null {
  const searchString = searchText.trim();
  if (searchString === activeSearch || (searchString.length > 0 && searchString.length < CRM_SEARCH_MIN_LENGTH)) {
    return null;
  }

  return searchString;
}

export function getCrmSearchRequest(searchText: string, pageSize: number) {
  return {
    pageNumber: 1,
    pageSize,
    searchString: searchText.trim(),
  };
}
